import { DMCObject } from "./DMCObject";
import Konva from "konva";

import store from "../../../store/store";

// TOOLS
const pathInfo = require("path");

export class DMCVideo extends DMCObject {
  constructor(name, konvaObject, source) {
    super(name, konvaObject);
    if (name == undefined || konvaObject == undefined) {
      return;
    }

    this.source = source;
    this.tryLoad = 0;
  }

  copyOption(DMCObject, creationController) {
    let newOption = super.copyOption(DMCObject, creationController);
    newOption.image = document.createElement("video");
    newOption.image.src = this.loadCorrectSource(DMCObject);
    return newOption;
  }

  createNewObject(DMCObject) {
    return new Konva.Image(DMCObject.konvaObjectOption);
  }

  delete() {
    this.konvaObjectOption.image.pause();
  }

  deselect() {
    this.konvaObjectOption.image.pause();
  }

  loadCorrectSource(DMCObject) {
    this.source = "";
    const nameDir = pathInfo.basename(DMCObject.projectPath);

    // TODO: Beware dirs.app before it was dirs.root but it doesn't work on player mode
    this.source =
      store.state.config.dirs.app +
      "temp/readingDirectory/projects/" +
      nameDir +
      "/media/" +
      pathInfo.basename(DMCObject.source);

    if (store.state.config.system.isCreation) {
      this.source = DMCObject.source;
    }

    return this.source;
  }

  save() {
    return [this.source];
  }

  select() {
    this.konvaObjectOption.image.play();
  }

  stopPreview() {
    // TODO: We reload to restart at 0 ???
    this.renderObject.image().load();
  }
}
